"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rfiCapabilitiesResponseSchema = void 0;
const zod_1 = require("zod");
const unique_1 = require("../../../common/schemas/helpers/unique");
const RfiCapabilities_1 = require("../../types/RfiCapabilities");
exports.rfiCapabilitiesResponseSchema = zod_1.z
    .object({
    capabilities: zod_1.z
        .nativeEnum(RfiCapabilities_1.RfiCapabilities)
        .array()
        .refine(...(0, unique_1.unique)("Capabilities must be unique")),
})
    .strict();
//# sourceMappingURL=rfiCapabilitiesResponseSchema.js.map